import React from 'react'

const Arithmetic = ({ columns }) => {

    return (
        <div class="row">
            <div class="col">
                <select></select>
            </div>

            <div class="col">
                <select></select>
            </div>

            <div class="col">
                <select></select>
            </div>
        </div>
    )
}

export default Arithmetic